import styled from "styled-components";
const DefaultFontFamily                 = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen'," +
                                            "'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'," +
                                            "sans-serif";

//const DefaultPageTitleBgColor           = "#002b70";
const DefaultPageTitleBgColor           = "#002b70";
const DefaultPageTitleBgColorError      = "darkorange";

const DefaultPageTitleTxtColor          = "#FFFFFF";

//const DefaultPageHeaderBgColor          = "whitesmoke";
//const DefaultPageFooterBgColor          = "whitesmoke";
const DefaultPageHeaderBgColor          = "whitesmoke";
const DefaultPageFooterBgColor          = "whitesmoke";

const DefaultTableTitleBgColor          = "#002b70";

const DefaultMaxScreenSize              = "575px";
const DefaultTableHeaderFontSize        = "12px";
const DefaultTablBodyFontSize           = "10px";
const DefaultTableTextValueSize         = "11px";
const DefaultTableHeaderBgColor         = "#3D84B8";

const handleActionBoxMode   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'sync':
            return 'darkorange';
        case 'add':
            return '#3D84B8';
        case 'update':
            return '#3D84B8';
        case 'download':
            return '#289672';
        case 'preview':
            return '#F05945';
        case 'upload':
            return 'darkorange';
        case 'delete':
            return 'red';
        default:
            return 'dimgrey';
        }
    } else {
        return 'dimgrey';
    }
}

const handleControlleColorMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#002b70';
        case 'success':
            //return '#B5CDA3';
            return 'darkgreen';
        case 'warning':
            //return '#FFBF86';
            return 'darkorange';
        case 'danger':
            return 'red';
        case 'preview':
            return '#F05945';
        default:
            return '#3c8dbc';
        }
    } else {
        return '#3c8dbc';
    }
}

const handleControlleColorHoverMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#3c8dbc';
        case 'success':
            return '#B5CDA3';
        case 'warning':
            return '#FFBF86';
            //return 'darkorange';
        case 'danger':
            //return '#F05945';
            return '#FF5C58';
        default:
            return '#3c8dbc';
        }
    } else {
        return '#3c8dbc';
    }
}
// -------------------------------------------------
const handleControllerTableColorMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#002b70';
        case 'success':
            //return '#B5CDA3';
            return 'darkgreen';
        case 'warning':
            //return '#FFBF86';
            return 'darkorange';
        case 'danger':
            return 'red';
        default:
            return '#3c8dbc';
        }
    } else {
        return '#3c8dbc';
    }
}

const handleControllerTableColorHoverMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#3c8dbc';
        case 'success':
            return '#B5CDA3';
        case 'warning':
            return '#FFBF86';
            //return 'darkorange';
        case 'danger':
            //return '#F05945';
            return '#FF5C58';
        default:
            return '#3c8dbc';
        }
    } else {
        return '#3c8dbc';
    }
}


// -------------------------------------------------
const BtnBacklightColorMode         = {
    default: '#3c8dbc',
    primary: '#3c8dbc',
    success: '#B5CDA3',
    warning: '#FFBF86',
    danger: 'red',
}

const BtnTextColorMode      = {
    default: '#002b70',
    primary: '#002b70',
    success: 'green',
    warning: 'darkorange',
    danger: 'red',
}

const BtnBgHoverColorMode   = {
    default: '#3c8dbc',
    primary: '#3c8dbc',
    success: 'darkgreen',
    //success: '#4E9F3D',
    warning: 'darkorange',
    danger: 'red',
}

const HandleHeaderColorMode = Mode => {
    if (typeof Mode !== 'undefined') {
        switch(Mode.toString().toLowerCase()) {
            case "normal":
                return '#3c8dbc';
            case "primary":
                return '#005792';
            case "warning":
                //return '#E2703A';
                return "darkorange";
            case "danger":
                return '#F05945';
            case "error":
                return 'red';
            case "success":
                return 'darkgreen';
            case "subject":
                return '#3c8dbc';
            case "information":
                return 'dimgrey';
            case "active":
                return '#22577A';
            case "inactive":
                //return 'dimgrey';
                return '#364E68';
            case "online":
                return '#4CA1A3';
            default:
                return '#3D84B8';
        }
    } else {
        return '#3D84B8';
    }    
}
const HandleTextColorMode = Mode => {
    if (typeof Mode !== 'undefined') {
        switch(Mode.toString().toLowerCase()) {
            case "normal":
                return '#3D84B8';
            case "primary":
                return '#002b70';
            case "warning":
                //return '#E2703A';
                return "darkorange";
            case "danger":
                return 'red';
            case "error":
                return '#F05454';
            case "success":
                return 'green';
            case "subject":
                return '#3c8dbc';
            case "information":
                return 'dimgrey';
            case "active":
                return '#22577A';
            case "inactive":
                return '#345B63';
            case "online":
                return '#4CA1A3';
            default:
                return 'darkgrey';
        }
    } else {
        return 'darkgrey';
    }    
}
// ===========================================
// BODY CONTAINER
// ===========================================
export const PageContainer = styled.div`
    display: inline-block;
    background-color: transparent;

    margin: auto;
    margin-top: 30px;

    width: 100%;
    height: 100%;
    overflow: hidden;

    font-family: ${(DefaultFontFamily)};

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        margin-top: 40px;
        transition: 0.3s ease-in-out;
    }
`;
// ===========================================
// HEADER
// ===========================================
export const PageHeader     = styled.div`
    width: 100%;
    background-color: transparent;
    position: fixed;
    top: 30;
    left: 0;
    display: inline-flexbox;

    z-index: 5;
`;

    export const HeaderContainer    = styled.div`
        display: block;

        border-bottom: 1px solid lightgray;
        text-align: right;
        width: 100%;
        height: 30px;
        background-color: ${(DefaultPageHeaderBgColor)};

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            //border-bottom: unset;
            height: 36px;
            transition: 0.3s ease-in-out;
        }
    `;
    export const PageTitleContainer = styled.div`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        justify-items: center;
        
        font-size: 10px;

        position: absolute;
        bottom: auto;
        top: 0px;
        left: 0px;
        right: auto;
        
        width: 150px;
        height: 24px;

        margin-top: 3px;
        margin-left: 0px;
        padding-left: 5px;

        padding-right: 0px;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        
        //border: solid 0.7px ${(DefaultPageTitleBgColor)};
        //background-color: ${(DefaultPageTitleBgColor)};
        border: solid 0.7px ${({IsError}) => (
            IsError?
            DefaultPageTitleBgColorError:DefaultPageTitleBgColor
        )}; 
        background-color: ${({IsError}) => (
            IsError?
            DefaultPageTitleBgColorError:DefaultPageTitleBgColor
        )}; 

        color: ${(DefaultPageTitleTxtColor)};

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        text-align: left;
        z-index: 3;

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            height: 28px;
            /* width: 170px;*/
            width: max-content;
            transition: 0.3s ease-in-out;
        }
    `;

    export const PageTitle          = styled.div`
        text-transform: uppercase;
        //font-size: 0.9em;
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '0.9em':`${FontSize}`
        )};
        font-weight: bold;
        text-align: left;

        display: inline-block;
        background-color: transparent;
        padding-top: 4px;
        padding-left: 2px;
        padding-bottom: 5px;

        margin-right: 20px;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            //font-size: 1em;
            font-size: ${({FontSizeLarge}) => (
                typeof FontSizeLarge !== 'string' || `${FontSizeLarge}`.trim() === ''?
                '1em':`${FontSizeLarge}`
            )};
            transition: 0.3s ease-in-out;
        }
    `; 
    // ------------------------------------------------------
    // CONTROLLER
    // ------------------------------------------------------
    export const ControllerBtnClear         = styled.div`
        background-color: white;        
        color: ${(DefaultPageTitleBgColor)};

        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;

        cursor: pointer;

        &:hover {
            color: #3c8dbc;
        }
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            width: 28px;
            height: 28px;
            transition: 0.3s ease-in-out;
        }
    `;
    export const ControllerContainer        = styled.div`
        position: absolute;
        top: 0px;
        left: auto;
        right: 0px;

        width: max-content;
        height: 25px;

        display: flex;
        flex-direction: row;

        padding-top: 3px;
        padding-bottom: 3px;
        padding-right: 3px;
        padding-left: 3px;

        background-color: transparent;

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            height: 30px;
            transition: 0.3s ease-in-out;
        }
    `;
    
    export const ControllerBtnTable              = styled.div`
        width: ${({Width}) => (
            typeof Width === 'number' && Width > 0 && Width <= 100?
            `${Width}%`: '60px'
        )};
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '9px':`${FontSize}`
        )};
        margin-top: ${({MarginTop}) => (
            typeof MarginTop === 'number' && MarginTop > 0?
            `${MarginTop}px`:'unset'
        )};
        background-color: ${({ Mode }) => handleControllerTableColorMode(Mode)};        
        color: #FFFFFF;
        border: solid 0.8px ${({ Mode }) => handleControllerTableColorMode(Mode)};    
        

        font-weight: bold;
        cursor: pointer;

        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        
        align-items: center;

        padding-top: 4px;
        padding-bottom: 4px;
        padding-right: 5px;
        padding-left: 5px;
        
        border-radius: 5px;


        margin-right: 3px;
        &:last-child {
            margin-right: unset;
        }
        &:hover {
            color: #FFFFFF;
            background-color: ${({ Mode }) => handleControllerTableColorHoverMode(Mode)};    
            border: solid 0.8px ${({ Mode }) => handleControllerTableColorHoverMode(Mode)}; 

            box-shadow: 0px 4px 14px -3px ${({Mode}) => (
                typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
                BtnBacklightColorMode.default
                :`${Mode}`.trim().toLowerCase() === 'primary'?
                BtnBacklightColorMode.primary
                :`${Mode}`.trim().toLowerCase() === 'success'?
                BtnBacklightColorMode.success
                :`${Mode}`.trim().toLowerCase() === 'warning'?
                BtnBacklightColorMode.warning
                :BtnBacklightColorMode.default
            )};
        }
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            //width: 98%;
            width: ${({IsFixedWidth, SmallWidth}) => (
                IsFixedWidth?
                undefined:
                typeof SmallWidth === 'number' && SmallWidth > 0 && SmallWidth <= 100?
                `${SmallWidth}%`:'98%'
            )};
            font-size: ${({SmallWidth}) => (
                typeof SmallWidth === 'number' && SmallWidth > 0 && SmallWidth <= 100?
                `calc(${SmallWidth - 5}%)`:undefined
            )};

            transition: 0.3s ease-in-out;
        }
    `;

    export const ControllerBtnTableText          = styled.div`
        display: flex;
        text-transform: uppercase;
        //@media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //    display: none;
        //    transition: 0.3s ease-in-out;
        //}
    `;

    export const ControllerBtn              = styled.div`
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}px`: '60px'
    )};
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '9px':`${FontSize}`
    )};
    background-color: #FFFFFF;
    color: ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        BtnTextColorMode.default
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        BtnTextColorMode.primary
        :`${Mode}`.trim().toLowerCase() === 'success'?
        BtnTextColorMode.success
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        BtnTextColorMode.warning
        :`${Mode}`.trim().toLowerCase() === 'danger'?
        BtnTextColorMode.danger
        :BtnTextColorMode.default
    )};
    border: solid 0.8px ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        //BtnTextColorMode.default
        'lightgrey'
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        //BtnTextColorMode.primary
        'lightgrey'
        :`${Mode}`.trim().toLowerCase() === 'success'?
        BtnTextColorMode.success
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        BtnTextColorMode.warning            
        :'lightgrey'
    )};

    font-weight: bold;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    
    align-items: center;

    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 5px;
    padding-left: 5px;
    
    border-radius: 5px;

    margin-right: 3px;
    &:last-child {
        margin-right: unset;
    }
    &:hover {
        color: #FFFFFF;
        background-color: ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBgHoverColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBgHoverColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBgHoverColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBgHoverColorMode.warning
            :`${Mode}`.trim().toLowerCase() === 'danger'?
            BtnBgHoverColorMode.danger
            :BtnBgHoverColorMode.default
        )};
        border: solid 0.8px ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBgHoverColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBgHoverColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBgHoverColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBgHoverColorMode.warning
            :`${Mode}`.trim().toLowerCase() === 'danger'?
            BtnBgHoverColorMode.danger
            :BtnBgHoverColorMode.default
        )};

        box-shadow: 0px 4px 14px -3px ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBacklightColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBacklightColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBacklightColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBacklightColorMode.warning
            :`${Mode}`.trim().toLowerCase() === 'danger'?
            BtnBacklightColorMode.danger
            :BtnBacklightColorMode.default
        )};
    }
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: max-content;
        transition: 0.3s ease-in-out;
    }
`;

    export const ControllerBtnIconLarge     = styled.div`
        display: none;
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            display: flex;
            transition: 0.3s ease-in-out;
        }        
    `;
    export const ControllerBtnIcon          = styled.div`
        display: flex;
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            display: none;
            transition: 0.3s ease-in-out;
        } 
    `;
    export const ControllerBtnIconFixed     = styled.div`
        display: flex;
    `;
    export const ControllerBtnText          = styled.div`
        display: flex;
        text-transform: uppercase;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            display: none;
            transition: 0.3s ease-in-out;
        }
    `;

// ===========================================
// BODY
// ===========================================
export const PageBody               = styled.div`
    width: 100%;
    margin-top: 30px;
    
    //padding-left: 5px;
    //padding-right: 5px;
    padding-left: 2px;
    padding-right: 2px;    

    padding-top: 0.5px;

    min-height: 97%;
    max-height: 97%;

    //background-color: transparent;
    background-color: transparent;

    padding-bottom: 30px;
    // ADD ON BIAR TENGAH
    //display: flex;
    //justify-content: center;
    //display: flex;
    //flex-direction: column;
    //justify-content: center;

    // ADD ON BIAR TENGAH
    display: ${({IsDashboard}) => (
        IsDashboard?
        undefined:'flex'
    )}; 
    
    justify-content: ${({IsDashboard}) => (
        IsDashboard?
        undefined:'center'
    )}; 

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //padding-left: unset;
        padding-right: unset;
        margin-top: 37px;
        transition: 0.3s ease-in-out;
    }
`;
// ===========================================
// FOOTER
// ===========================================
export const PageFooter             = styled.div`
    width: 100%;
    background-color: transparent;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 28px;
    font-size: 1em;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    z-index: 15;
`;

export const FooterContainer        = styled.div`
    width: 100%;
    height: 100%;

    background-color: ${(DefaultPageFooterBgColor)};
    font-size: 0.9em;

    display:inline-flex;
    justify-content: space-between; 
    
    border-top: solid 0.3px lightgray;
`;

export const FooterContent          = styled.div`
    font-size: 0.9em;
    background-color: transparent;
    
    margin-left: ${({isLeft}) => (
        isLeft?
        '5px':'unset'
    )};
    margin-right: ${({isLeft}) => (
        !isLeft?
        '5px':'unset'
    )};

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: auto;
`;
    export const DataOptionContainer    = styled.div`
        height: 100%;
        display: flexbox;
        background-color: transparent;

        align-items: center;
        justify-items: center;
    `;
    export const DataOption             = styled.select`
        width: 150px;
        height: 22px;
        
        /*padding: 5px 3px;*/

        font-size: 9px;

        display: inline-block;
        border: 0.8px solid #ccc;
        box-sizing: border-box;
        border-radius: 5px;
        /*box-shadow: 0px 2px 2px #ccc;*/

        padding-left: 5px;
        padding-right: 5px;

        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;

        background-color: white;
        color: #002b70;
        font-weight: bold;
    `;

    export const DataCountContainer = styled.div`
        display: flex;

        align-items: center;            
        background-color: #126E82;
        width: max-content;

        border-radius: 5px;
        border: solid 0.3px transparent;

        padding-left: 5px;
        padding-right: 5px;

        height: 20px;
    `;
    export const DataCount          = styled.div`
        font-size: 0.8em;
        background-color: transparent;
        display: inline-flex;
            
        vertical-align: middle;
        text-align: right;
        color: #fff;

        font-weight: bold;
    `;
    export const ActionBoxContainer = styled.div`
        display: flex;
            
        align-items: center;            
        //handleActionBoxMode
        background-color: ${({ boxmode }) => handleActionBoxMode(boxmode)};

            width: max-content;

            border-radius: 5px;
            border: solid 0.3px transparent;

            padding-left: 5px;
            padding-right: 5px;

            margin-right: 3px;

            height: 20px;
        `;
        export const ActionBox          = styled.div`
            font-size: 0.7em;
            background-color: transparent;
            display: inline-flex;
            
            //text-transform: uppercase;
            text-transform: ${({IsUpperCase}) => (
                !IsUpperCase?
                'normal':'uppercase'
            )};
            
            vertical-align: middle;
            text-align: right;
            color: #fff;

            font-weight: bold;
        `;
// ===========================================
// NAVIGATIONS
// ===========================================
export const NavPageContainer       = styled.div`
    //width: 100%;
    width: max-content;

    position: fixed;    
    //top: 60px;
    top: 60px;
    z-index: 6;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    justify-content: center;
    color: ${(DefaultPageTitleBgColor)};
    //background-color: whitesmoke;
    background-color: ${(DefaultPageHeaderBgColor)};

    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '12px':`${FontSize}`
    )};

    font-weight: bold;
    height: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    
    // ADD ON BIAR TENGAH
    padding-left: 5px;
    //padding-right: 3px;
    padding-right: 5px;

    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: solid 0.5px lightgray;
    border-right: solid 0.5px lightgray;
    border-bottom: solid 0.5px lightgray;

    overflow: hidden;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        background-color: ${(DefaultPageHeaderBgColor)};
        position: fixed;
        top: 76px;

        height: 28px;

        padding-bottom: 5px;
        //padding-bottom: 4px;
        overflow: hidden;
        //border-bottom: solid 0.4px lightgrey;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;

        font-size: 12px;
        transition: 0.3s ease-in-out;
    }
`;
export const NavPageBoxLeft         = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    background-color: transparent;    
`;
    export const NavPageBtnLeft     = styled.div.attrs(({ IsFirstPage }) => ({
        title: IsFirstPage? 'Go to first page':'Go to previous page',
      }))`
        color: ${({IsDisabled}) => (
            IsDisabled?
            'lightgrey':DefaultPageTitleBgColor
        )};
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;

        background-color: white;
        margin-right: 3px;
        padding-left: 3px;
        padding-right: 3px;

        height: 20px;
        border-radius: 5px;
        border: solid 0.3px lightgrey;
        
        cursor: ${({IsDisabled}) => (
            IsDisabled?
            'unset':'pointer'
        )};

        &:hover {
            color: ${({IsDisabled}) => (
                IsDisabled?
                'lightgrey': '#FFFFFF'
            )};
            background-color: ${({IsDisabled}) => (
                IsDisabled?
                'white':DefaultPageTitleBgColor
            )};
            border: ${({IsDisabled}) => (
                IsDisabled?
                'solid 0.3px lightgrey':`solid 0.3px ${DefaultPageTitleBgColor}`
            )};
        }

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            height: 28px;
            width: 28px;
            border-radius: 8px;
            transition: 0.3s ease-in-out;
        }
    `;
export const NavPageBoxNumber       = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    justify-items: center;

    background-color: white;
    padding-left: 3px;
    padding-right: 3px;

    width: max-content;
    min-width: 50px;
    
    border-radius: 5px;
    border: solid 0.3px lightgrey;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select:none;
`;
    export const NavPageNumber      = styled.div`
        display: flex;
        align-items: center;
        justify-items: center;
        height: 20px;  
        
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            height: 28px;
            //border-radius: 8px;
            transition: 0.3s ease-in-out;
        }
    `;
export const NavPageBoxRight        = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    //height: 20px;
    background-color: transparent;
`;
    export const NavPageBtnRight    = styled.div.attrs(({ IsLastPage }) => ({
        title:  IsLastPage? 'Go to last page':'Go to next page'
      }))`
        color: ${({IsDisabled}) => (
            IsDisabled?
            'lightgrey':DefaultPageTitleBgColor
        )};
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        
        background-color: white;
        margin-left: 3px;
        padding-left: 3px;
        padding-right: 3px;

        height: 20px;
        border-radius: 5px;
        border: solid 0.3px lightgrey;

        //cursor: pointer;
        cursor: ${({IsDisabled}) => (
            IsDisabled?
            'unset':'pointer'
        )};
        &:hover {
            color: ${({IsDisabled}) => (
                IsDisabled?
                'lightgrey': '#FFFFFF'
            )};
            background-color: ${({IsDisabled}) => (
                IsDisabled?
                'white':DefaultPageTitleBgColor
            )};
            border: ${({IsDisabled}) => (
                IsDisabled?
                'solid 0.3px lightgrey':`solid 0.3px ${DefaultPageTitleBgColor}`
            )};
        }

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            height: 28px;
            width: 28px;
            border-radius: 8px;
            transition: 0.3s ease-in-out;
        }
    `;
// ===========================================
// TABLE
// ===========================================
export const BoxTableContainer      = styled.div`
    //margin-top: 1mm;
    //margin-top: 31px;
    margin-top: 33px;

    //width: calc(100% - 10px);
    width: calc(100% - 10px);
    margin-right: 4px;

    background-color: transparent;

    display: flexbox;
    flex-direction: column;
    align-items: center;
    justify-items: center;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        margin-top: 38px;
        margin-right: unset;
        width: 100%;
        transition: 0.3s ease-in-out;
    }
`;
export const BoxTable               = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    background-color: transparent;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        padding-top: 3px;
        padding-left: 3px;
        padding-right: 3px;
        width: 98%;
        transition: 0.3s ease-in-out;
    }
`;
export const BoxTableHeader         = styled.div`
    display: flex;
    overflow: hidden;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: none;
        transition: 0.3s ease-in-out;
    }
`;
    export const BoxTableHeaderRow      = styled.div`    
        background-color: transparent;
        display: flexbox;
        flex-direction: row;
        
        width: 100%;
    `;
    export const BoxTableHeaderData     = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;

        background-color: ${({ Color }) => HandleHeaderColorMode(Color)};        
        color: white;

        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTableHeaderFontSize:`${FontSize}`
        )};
        text-transform: uppercase;

        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: '100%'
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )}; 

        border-right: solid 0.5px white;
        overflow: hidden;
        &:first-child {
            border-left: solid 0.4px ${(DefaultTableHeaderBgColor)};
        }
        &:last-child {            
            border-right: solid 0.4px ${(DefaultTableHeaderBgColor)}; 
        }
    `;

    export const BoxTableHeaderText         = styled.div`
        padding-top: 3px;
        padding-bottom: 3px;
    `;

export const BoxTableBody           = styled.div`
    display: flex;
    flex-direction: column;

    background-color: transparent;
    border-left: solid 0.4px lightgrey;
    border-right: solid 0.4px lightgrey;
    border-bottom: solid 0.4px lightgrey;

    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow: hidden;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
        border-bottom-left-radius: unset;
        border-bottom-right-radius: unset;

        border-left: unset;
        border-right: unset;
        border-bottom: unset;
        //padding-top: 5px;
        padding-bottom: 5px;

        transition: 0.3s ease-in-out;
    }
`;
    export const BoxTableBodyRow            = styled.div`    
        background-color: white;
        display: flexbox;
        flex-direction: row;
        
        width: 100%;
        border-bottom: solid 0.4px lightgrey;

        //padding-bottom: 3px;

        &:last-child {
            border-bottom: unset;
        }
        &:hover {
            background-color: whitesmoke;
        }
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            width: 99%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            transition: 0.3s ease-in-out;

            border: solid 0.4px lightgrey;
            border-radius: 5px;

            margin-bottom: 5px;
            &:first-child {
                border-top: solid 0.4px lightgrey;
            }
            &:last-child {
                margin-bottom: unset;
                border-bottom: solid 0.4px lightgrey;
            }
            &:hover {
                background-color: white;
                border: solid 0.4px ${(DefaultTableHeaderBgColor)};
                box-shadow: 0px 4px 14px -3px ${(DefaultTableHeaderBgColor)};
            }
        }
    `;
    export const BoxTableBodyData       = styled.div`
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};

        background-color: transparent;
        border-right: solid 0.4px lightgrey;
        padding-top: 3px;
        padding-bottom: 3px;

        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
        
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: '100%'
        )};
        &:first-child {
            padding-top: unset;
            border-left: solid 0.4px transparent;
        }
        &:last-child {
            border-right: unset;
        }

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            border: unset;
            border-right: unset;
            width: 100%;
            overflow: hidden;
            
            //border-bottom: solid 0.3px lightgrey;
            border-bottom: ${({NoBottomBorder}) => (
                NoBottomBorder?
                'unset': 'solid 0.3px lightgrey'
            )};
            &:last-child {
                border-bottom: unset;

                margin-bottom: 3px;
            }

            transition: 0.3s ease-in-out;
        }
    `;
    
    export const BoxTableDataRow        = styled.div`
        //background-color: transparent;
        background-color: transparent;
        display: flex;
        //align-items: center;
        align-items: ${({VAlign}) => (
            typeof VAlign === 'string' && VAlign.trim() !== ''?
                VAlign.trim().toLowerCase() === 'top'?
                `flex-start`
                :VAlign.trim().toLowerCase() === 'bottom'?
                `flex-end`
                :VAlign.trim().toLowerCase() === 'middle' || VAlign.trim().toLowerCase() === 'center'?
                `center`
                :'center'
            :'center'
        )};
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: '98.5%'
        )};
    
        margin-top:  ${({MarginTop}) => (
            typeof MarginTop === 'number' && MarginTop > 0?
            `${MarginTop}px`:'unset'
        )};

        justify-content: ${({IsJustify, IsCentered}) => (
            IsJustify?
            'space-between'
            :IsCentered?
            'center'
            //'unset'
            :undefined
        )};
        
        overflow: hidden;
        //padding-left: 5px;
        //padding-right: 5px;        
        padding-left:${({NoPaddingLeft, CustomPaddingLeft}) => (
            NoPaddingLeft?
            'none'
            :
            typeof CustomPaddingLeft === 'number' && CustomPaddingLeft > 0?
            `${CustomPaddingLeft}px`:'5px'
        )};
        padding-right:${({NoPaddingRight, CustomPaddingRight}) => (
            NoPaddingRight?
            'none'
            :typeof CustomPaddingRight === 'number' && CustomPaddingRight > 0?
            `${CustomPaddingRight}px`:'5px'
        )};
        
        //margin-bottom: 3px;
        margin-bottom: ${({NoMarginBottom, CustomMarginBottom}) => (
            NoMarginBottom?
            'none':
            typeof CustomMarginBottom === 'number' && CustomMarginBottom > 0?
            `${CustomMarginBottom}px`:'3px'
        )};
        
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            //background-color: pink;
            //width: 98.5%;
            //padding-left: 3px;
            width: 98%;
            //padding-left: 3px;
            //padding-right: 1px;
            padding-left: ${({NoPaddingLeft, CustomPaddingLeft}) => (
                NoPaddingLeft?
                'none':
                typeof CustomPaddingLeft === 'number' && CustomPaddingLeft > 0?
                `${CustomPaddingLeft}px`:'3px'
            )};
            padding-right: ${({NoPaddingRight, CustomPaddingRight}) => (
                NoPaddingRight?
                'none'
                :typeof CustomPaddingRight === 'number' && CustomPaddingRight > 0?
                `${CustomPaddingRight}px`:'1px'
            )};

            //margin-bottom: 3px;
            margin-bottom: ${({NoMarginBottom, CustomMarginBottom}) => (
                NoMarginBottom?
                'none':
                typeof CustomMarginBottom === 'number' && CustomMarginBottom > 0?
                `${CustomMarginBottom}px`:'3px'
            )};
            &:first-child {
                margin-bottom: unset;
            }
            transition: 0.3s ease-in-out;
        }
    `;
    // TABLE DATA CONTENT
    export const BoxTableDataTitle      = styled.div`
        margin-top: 3px;             

        background-color: transparent;
        color: ${(DefaultTableTitleBgColor)};
        width: 100%;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    `;
    export const TableDataTitle         = styled.div`
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '12px':`${FontSize}`
        )};
        padding-left: 3px;

        font-weight: bold;
        text-align: left;

        background-color: transparent;
        max-width: 90%;

        overflow: hidden;
        white-space: pre;
        word-wrap: break-word;
        text-overflow: ellipsis;
    `;
    export const TableDataControllerBox = styled.div`     
        padding-right: 3px;
        display: flex;
        flex-direction: row;
        align-items: center;
        
        justify-items: center;
        justify-content: space-evenly;
        background-color: unset;
    `;
    export const TableDataController    = styled.div`
        background-color: transparent;
        color: ${({ Mode }) => handleControlleColorMode(Mode)};
        cursor: pointer;
        display: flexbox;
        margin-right: 5px;
        &:first-child {
            margin-left: 3px;
        }
        &:last-child {
            margin-right: unset;
        }

        &:hover {
            color: ${({ Mode }) => handleControlleColorHoverMode(Mode)};
        }
        &:focus {
            color: ${({ Mode }) => handleControlleColorHoverMode(Mode)};
        }
    `;
    export const TableDataControllerCounter = styled.div`
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '8px':`${FontSize}`
        )}; 
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )};  
        padding-left: 2px;
        padding-right: 2px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    `;


    export const TableDataLabel = styled.div`
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width < 100?
            `${Width}%`
            :typeof Width === 'number' && Width === 100?
            '100%'
            : '18%'
        )};
        font-weight: ${({IsNotBold}) => (
            IsNotBold?
            'normal':'bold'
        )}; 
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};
        color: darkgrey;        
        //text-align: left;
        text-align: ${({IsCentered}) => (
            IsCentered?
            'center':'left'
        )}; 

        display: block;
        
        max-width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width < 100?
            `calc(${Width} + 0.5)%`
            :typeof Width === 'number' && Width === 100?
            '100%'
            : '18%'
        )};
        overflow: hidden;
        white-space: pre;
        word-wrap: break-word;
        text-overflow: ellipsis;
    `;

    export const TableDataSeparator = styled.div`
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};
        font-weight: bold;
        display: block;
        color: darkgrey;
        text-align: center;
        margin-left: 2px;
        margin-right: 2px;
    `;

    export const TableDataValue = styled.div`
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: 'max-content' //'82%'
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )}; 
        text-transform: ${({IsUpperCase}) => (
            IsUpperCase?
            'uppercase':'normal'
        )}; 
        font-style: ${({IsItalic}) => (
            IsItalic?
            'italic':'normal'
        )}; 
        font-size: ${({FontSize, IsTextArea}) => (
            !IsTextArea?
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTableTextValueSize:`${FontSize}`
            :
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};

        color: ${({ Color }) => HandleTextColorMode(Color)};
        text-align: left;
        display: block;
        
        white-space: ${({IsTextArea}) => (
            IsTextArea?
            'pre':'unset'
        )};

        overflow: ${({IsTextArea}) => (
            IsTextArea?
            'auto':'unset'
        )};
        cursor: ${({IsLink}) => (
            IsLink?
            'pointer':'default'
        )};
        &:hover {
            text-decoration: ${({IsLink}) => (
                IsLink?
                'underline':'undefined'
            )}; 
        }
    `;

    export const TableDataColumnBox = styled.div`
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: '100%'
        )};

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            background-color: transparent;           
            //width: 95%;
            width: 98%;
            //width: 100%;
            margin-left: 2px;
            //&:first-child {
            //    margin-left: unset;
            //}
            &:last-child {
                //margin-right: 2px;
            }
            transition: 0.3s ease-in-out;
        }
    `;
    export const TableDataColumnHeader  = styled.div`
        display: ${({IsSmallOnly}) => (
            IsSmallOnly?
            'none':'flex'
        )};
        align-items: ${({IsSmallOnly}) => (
            IsSmallOnly?
            'unset':'center'
        )};
        justify-content: ${({IsSmallOnly}) => (
            IsSmallOnly?
            'unset':'center'
        )};
        font-weight: ${({IsNotBold}) => (
            IsNotBold?
            'normal':'bold'
        )}; 

        margin-top:  ${({IsSmallOnly, MarginTop}) => (
            !IsSmallOnly?
                typeof MarginTop === 'number' && MarginTop > 0?
                `${MarginTop}px`:'unset'
            :'unset'
        )};

        background-color: ${({ Color }) => HandleHeaderColorMode(Color)};
        color: #FFFFFF;

        //font-weight: bold;
        text-transform: uppercase;

        //padding-top: 1px;
        //padding-bottom: 1px;
        padding-top: ${({IsSmallOnly}) => (
            IsSmallOnly?
            '1px':'2px'
        )};
        padding-bottom: ${({IsSmallOnly}) => (
            IsSmallOnly?
            '1px':'2px'
        )};

        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};

        border-radius: 5px;
        
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;

        overflow: hidden;
        
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            margin-top:  ${({IsSmallOnly, MarginTop}) => (
                IsSmallOnly?
                    typeof MarginTop === 'number' && MarginTop > 0?
                    `${MarginTop}px`:'unset'
                :'unset'
            )};
            display: ${({IsSmallOnly}) => (
                IsSmallOnly?
                'flex':'flex'
            )};
            align-items: ${({IsSmallOnly}) => (
                IsSmallOnly?
                'center':'center'
            )};
            justify-content: ${({IsSmallOnly}) => (
                IsSmallOnly?
                'center':'center'
            )};
            font-weight: bold;
            font-size: ${({IsSmallOnly}) => (
                IsSmallOnly?
                'calc(90%)':`calc(80%)`
            )};
            padding-top: ${({IsSmallOnly}) => (
                IsSmallOnly?
                '2px':'4px'
            )};
            padding-bottom: ${({IsSmallOnly}) => (
                IsSmallOnly?
                '2px':'4px'
            )};
            transition: 0.3s ease-in-out;
        }
    `;
    export const TableDataColumnValue   = styled.div`
        margin-top: 2px;
        color: ${({ Color }) => HandleTextColorMode(Color)};        
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )};
        display: flex;
        //justify-items: center;
        align-items: center;
        justify-content: ${({Align}) => (
        typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'left'?
            'flex-start'
            :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'right'?
            'flex-end'
            :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'center'?
            'center'
            :'center'
            )};
        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            font-size: 11px;
            transition: 0.3s ease-in-out;
        }
    `;
    export const TableDataColumnIcon   = styled.div`
        margin-top: 2px;
        color: ${({ Color }) => HandleTextColorMode(Color)};        
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )};
        display: flex;
        align-items: center;
        cursor: ${({IsLink}) => (
            IsLink?
            'pointer':'default'
        )};
        justify-content: ${({Align}) => (
        typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'left'?
            'flex-start'
            :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'right'?
            'flex-end'
            :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'center'?
            'center'
            :'center'
            )};

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            font-size: 11px;
            transition: 0.3s ease-in-out;
        }
    `;

// ===========================================
// LOGO
// ===========================================
export const TableDataLogoContainer = styled.div`
    display: flex;
    background-color: white;
    width: 100%;    
    overflow: hidden;
`;
export const TableDataLogoFrame     = styled.div`
    width: 98%;
    height: 75px;
    background-color: transparent;  
  
    display: block;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 5px;

    margin-left: auto;
    margin-right: auto;

    overflow: hidden;
`;
export const TableDataLogo          = styled.img`
    width: 340px;    
    height: 70px;
    background-color:transparent;
      
    display: block;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    opacity: unset;
    margin-top: 3px;
`;
// ===========================================
// ISSUE COUNTER DAYS
// ===========================================
export const TableDataColumnDurations       = styled.div`
    background-color: transparent;
    display: flex;
    flex-direction: column;

    color: black;
    padding-left: 1px;
    padding-right: 1px;
    padding-top: 5px;
    //padding-bottom: 1px;
    padding-bottom: ${({BorderBottom}) => (
        BorderBottom?
        '5px': '1px'
    )};

    align-items: ${({IsCentered}) => (
        IsCentered?
        'center': undefined
    )};

    border-bottom: ${({BorderBottom}) => (
        BorderBottom?
        'solid 0.4px lightslategray': undefined
    )};
`;
export const TableDataColumnDurationsRow    = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`:'unset'
    )};
    display: flex;
    justify-content: space-between;

    border-bottom: ${({NoBottomBorder}) => (
        NoBottomBorder?
        'none': 'solid 0.3px lightslategray'
    )};

    &:first-child {
        margin-top: unset;
    }
    
`;
export const TableDataColumnDurationLabel   = styled.div`
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultTablBodyFontSize:`${FontSize}`
    )};
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )}; 
    color: lightslategray;
`;
export const TableDataColumnDurationValue   = styled.div`
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultTablBodyFontSize:`${FontSize}`
    )};
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )}; 
    color: ${({ Color }) => HandleTextColorMode(Color)};
`;
// ===========================================
// TABLE INSIDE TABLE
// ===========================================
export const TableInsideContainer   = styled.div`
    background-color: transparent;

    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`:'unset'
    )};
    margin-left: ${({MarginLeft}) => (
        typeof MarginLeft === 'number' && MarginLeft > 0?
        `${MarginLeft}px`:'unset'
    )};
    //width: calc(100% - 10px);
    //width: 99%;
    width: 100%;

    display: flexbox;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //margin-top: 38px;
        width: 100%;
        display: flex;
        justify-items: center;
        transition: 0.3s ease-in-out;
    }
`;
export const TableInsideBox         = styled.div`
    width: 99%;
    display: flex;
    flex-direction: column;

    background-color: transparent;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        padding-top: 3px;
        //padding-left: 3px;
        //padding-right: 3px;
        width: 99%;
        //padding-right: unset;
        transition: 0.3s ease-in-out;
    }
`;
export const TableInsideHeader      = styled.div`
    display: flex;
    overflow: hidden;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`;
export const TableInsdeHeaderRow    = styled.div`
    background-color: transparent;
    display: flexbox;
    flex-direction: row;    
        
    width: 100%;
`;
export const TableInsdeHeaderData   = styled.div`
    display: flex;
        align-items: center;
        justify-content: center;

        background-color: ${({ Color }) => HandleHeaderColorMode(Color)};        
        color: white;

        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTableHeaderFontSize:`${FontSize}`
        )};
        text-transform: uppercase;

        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: '100%'
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )}; 

        border-right: solid 0.5px white;
        overflow: hidden;
        &:first-child {
            border-left: solid 0.4px ${(DefaultTableHeaderBgColor)};
        }
        &:last-child {            
            border-right: solid 0.4px ${(DefaultTableHeaderBgColor)}; 
        }
`;
export const TableInsdeHeaderText   = styled.div`
    padding-top: 3px;
    padding-bottom: 3px;
`;

export const TableInsideBody        = styled.div`
    display: flex;
    flex-direction: column;

    background-color: transparent;
    border-left: solid 0.4px lightgrey;
    border-right: solid 0.4px lightgrey;
    border-bottom: solid 0.4px lightgrey;

    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow: hidden;
`;
export const TableInsideBodyRow     = styled.div`
    background-color: white;
    display: flexbox;
    flex-direction: row;        
    width: 100%;
    border-bottom: solid 0.4px lightgrey;    
    &:last-child {
        border-bottom: unset;
    }
    &:hover {
        background-color: whitesmoke;
    }
`;
export const TableInsideBodyData    = styled.div`
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultTablBodyFontSize:`${FontSize}`
    )};

    background-color: transparent;
    border-right: solid 0.4px lightgrey;
    //padding-top: 3px;
    //padding-bottom: 3px;
    padding-top: ${({NoPaddingTop, CustomPaddingTop}) => (
        NoPaddingTop?
        'none'
        :
        typeof CustomPaddingTop === 'number' && CustomPaddingTop > 0?
        `${CustomPaddingTop}px`:'3px'
    )};
    padding-bottom: ${({NoPaddingBottom, CustomPaddingBottom}) => (
        NoPaddingBottom?
        'none'
        :
        typeof CustomPaddingBottom === 'number' && CustomPaddingBottom > 0?
        `${CustomPaddingBottom}px`:'3px'
    )};

    overflow: hidden;
        
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 1 && Width <= 100?
        `${Width}%`: '100%'
    )};
    &:first-child {
        padding-top: unset;
        border-left: solid 0.4px transparent;
    }
    &:last-child {
        border-right: unset;
    }
`;


// ========================================================================
// SYSTEM INFORMATION
// ========================================================================
export const SysInfoContainer       = styled.div`
    display: inline-flex;
    flex-direction: column;
    
    background-color: transparent;
    width: 98%;
    margin-right: 10px;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        padding-top: 3px;
        width: 99%;
        margin-right: 5px;
        transition: 0.3s ease-in-out;
    }
`;

export const SysInfoParagraph       = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;    
    background-color: transparent;
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        `14px`:`${FontSize}`
    )};
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};
`;

export const SysInfoRowLine         = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};

    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: '100%'
    )};
    
    display: ${({IsMultiRow}) => (
       !IsMultiRow?
       'flex':'inline-flex'
    )};    
    flex-direction: ${({IsMultiRow}) => (
       !IsMultiRow?
       'row':'column'
    )};
    flex-wrap: nowrap;
    
    justify-content: ${({IsMultiRow}) => (
        IsMultiRow?
       'unset':'space-between'
    )};
    background-color: transparent;
    padding-top: 1px;
    padding-bottom: 1px;

    //overflow: hidden;
    margin-bottom: 1mm;
    &:last-child {
        margin-bottom: unset;
    }
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 100%;        
        display: ${({IsMultiRow}) => (
            !IsMultiRow?
            'inline-flex'
            :'inline-flex'
        )};
        flex-direction: column;

        transition: 0.3s ease-in-out;
    }
`;
// ========================================================================